import { render, staticRenderFns } from "./SingleLink.vue?vue&type=template&id=25811dcc&scoped=true"
import script from "./SingleLink.vue?vue&type=script&lang=js"
export * from "./SingleLink.vue?vue&type=script&lang=js"
import style0 from "./SingleLink.vue?vue&type=style&index=0&id=25811dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25811dcc",
  null
  
)

export default component.exports